import { useState } from "react";

const C = { green:"#0a6e4e", navy:"#00283c", gold:"#f5a623", goldD:"#d4891a",
  ink:"#0b1f18", inkL:"#4a6b5c", greenL:"#e4f0eb", cream:"#fdfaf4",
  border:"#e2e8ef", white:"#ffffff" };

const STEPS = [
  { id:"profile",  icon:"👤", title:"Complete Your Profile",    sub:"Help employers find the right you" },
  { id:"prefs",    icon:"🎯", title:"Set Your OJT Preferences", sub:"We'll match you to the best opportunities" },
  { id:"explore",  icon:"🚀", title:"You're All Set!",          sub:"Start exploring OJT opportunities" },
];

const COURSES = [
  "BS Computer Science","BS Information Technology","BS Information Systems",
  "BS Computer Engineering","BS Electronics Engineering","BS Electrical Engineering",
  "BS Industrial Engineering","BS Mechanical Engineering","BS Civil Engineering",
  "BS Chemical Engineering","BS Geodetic Engineering","BS Environmental Engineering",
  "BS Accountancy","BS Management Accounting","BS Business Administration",
  "BS Marketing Management","BS Financial Management","BS Human Resource Management",
  "BS Entrepreneurship","BS Operations Management","BS Supply Chain Management",
  "BS Tourism Management","BS Hotel and Restaurant Management","BS Hospitality Management",
  "BS Nursing","BS Pharmacy","BS Medical Technology","BS Radiologic Technology",
  "BS Physical Therapy","BS Nutrition and Dietetics","BS Public Health",
  "BS Psychology","BS Social Work","BS Political Science","BS Economics",
  "BS Communication","BS Journalism","BS Broadcasting","BS Multimedia Arts",
  "BS Architecture","BS Interior Design","BS Industrial Design","BS Graphic Design",
  "BS Education","Bachelor of Elementary Education","Bachelor of Secondary Education",
  "BS Criminology","BS Biology","BS Chemistry","BS Mathematics","BS Statistics",
  "BS Agriculture","BS Marine Biology","BS Environmental Science","BS Food Technology",
  "Other",
];

const INDUSTRIES = [
  { icon:"💻", label:"Information Technology" },
  { icon:"🏦", label:"Banking & Finance" },
  { icon:"📢", label:"Marketing & Advertising" },
  { icon:"🏥", label:"Healthcare" },
  { icon:"🏗️", label:"Engineering & Construction" },
  { icon:"🎓", label:"Education" },
  { icon:"🛎️", label:"Hospitality & Tourism" },
  { icon:"⚖️", label:"Legal & Compliance" },
  { icon:"📊", label:"Accounting & Audit" },
  { icon:"🎨", label:"Creative & Design" },
  { icon:"📦", label:"Logistics & Supply Chain" },
  { icon:"🌐", label:"Media & Communications" },
];

const SETUPS = [
  { icon:"🏢", label:"On-site",  sub:"Work from the office" },
  { icon:"🏠", label:"Remote",   sub:"Work from anywhere" },
  { icon:"🔄", label:"Hybrid",   sub:"Mix of both" },
  { icon:"💡", label:"Any",      sub:"Open to all setups" },
];

export default function OnboardingFlow({ user, supabase, onComplete }) {
  const [step, setStep]         = useState(0);
  const [saving, setSaving]     = useState(false);
  const [profile, setProfile]   = useState({
    course: "", year_level: "", bio: "", skills: "",
  });
  const [prefs, setPrefs] = useState({
    industries: [], setup: "Any", location: "", hours: 486,
  });

  const progress = ((step) / (STEPS.length - 1)) * 100;

  const saveAndNext = async () => {
    setSaving(true);
    if (step === 0) {
      const skillsArr = profile.skills.split(",").map(s => s.trim()).filter(Boolean);
      await supabase.from("profiles").update({
        course:     profile.course,
        year_level: profile.year_level,
        bio:        profile.bio,
      }).eq("id", user.id);
    }
    if (step === 1) {
      // Save preferences as profile metadata
      await supabase.from("profiles").update({
        coordinator_notes: JSON.stringify({
          preferred_industries: prefs.industries,
          preferred_setup:      prefs.setup,
          preferred_location:   prefs.location,
          required_hours:       prefs.hours,
        })
      }).eq("id", user.id);
    }
    setSaving(false);
    if (step < STEPS.length - 1) setStep(s => s + 1);
    else onComplete();
  };

  const toggleIndustry = (label) => {
    setPrefs(p => ({
      ...p,
      industries: p.industries.includes(label)
        ? p.industries.filter(i => i !== label)
        : p.industries.length < 4 ? [...p.industries, label] : p.industries
    }));
  };

  return (
    <div style={{ minHeight:"100vh", background:`linear-gradient(135deg,${C.navy} 0%,#003d52 60%,#0a3828 100%)`,
      display:"flex", alignItems:"center", justifyContent:"center", padding:24,
      fontFamily:"'DM Sans',sans-serif" }}>
      <style>{`
        @keyframes slideUp { from{opacity:0;transform:translateY(24px)} to{opacity:1;transform:none} }
        .ob-card { animation: slideUp .5s cubic-bezier(.22,1,.36,1) both; }
        .chip { border:2px solid rgba(255,255,255,.15); border-radius:100px; padding:8px 16px;
          cursor:pointer; font-size:13px; font-weight:600; color:rgba(255,255,255,.7);
          background:rgba(255,255,255,.06); transition:all .18s; display:inline-flex; align-items:center; gap:6px; }
        .chip:hover { border-color:rgba(245,166,35,.5); color:#f5a623; }
        .chip.active { border-color:#f5a623; background:rgba(245,166,35,.15); color:#f5a623; }
        .ob-input { width:100%; padding:11px 14px; border-radius:10px;
          border:1.5px solid rgba(255,255,255,.15); background:rgba(255,255,255,.08);
          color:#fff; font-size:14px; font-family:inherit; outline:none;
          transition:border-color .15s; box-sizing:border-box; }
        .ob-input:focus { border-color:#f5a623; }
        .ob-input::placeholder { color:rgba(255,255,255,.35); }
        select.ob-input option { background:#00283c; color:#fff; }
      `}</style>

      <div style={{ maxWidth:560, width:"100%" }}>

        {/* Logo */}
        <div style={{ textAlign:"center", marginBottom:28 }}>
          <img src="/OJT_logo.png" alt="OJT Hub" style={{ height:44, objectFit:"contain",
            filter:"brightness(0) invert(1)", opacity:.9 }} />
        </div>

        {/* Progress */}
        <div style={{ marginBottom:28 }}>
          <div style={{ display:"flex", justifyContent:"space-between", marginBottom:10 }}>
            {STEPS.map((s, i) => (
              <div key={s.id} style={{ display:"flex", alignItems:"center", gap:6 }}>
                <div style={{
                  width:28, height:28, borderRadius:"50%",
                  background: i <= step ? C.gold : "rgba(255,255,255,.12)",
                  display:"flex", alignItems:"center", justifyContent:"center",
                  fontSize:13, fontWeight:900,
                  color: i <= step ? C.navy : "rgba(255,255,255,.4)",
                  transition:"all .3s",
                }}>
                  {i < step ? "✓" : i + 1}
                </div>
                <span style={{ fontSize:12, color: i === step ? "#fff" : "rgba(255,255,255,.4)",
                  fontWeight: i === step ? 700 : 400, display: i > 1 ? "none" : "block" }}>
                  {s.title.split(" ").slice(0,2).join(" ")}
                </span>
              </div>
            ))}
          </div>
          <div style={{ height:4, borderRadius:100, background:"rgba(255,255,255,.1)", overflow:"hidden" }}>
            <div style={{ height:"100%", borderRadius:100, background:C.gold,
              width:`${progress}%`, transition:"width .5s cubic-bezier(.22,1,.36,1)" }} />
          </div>
        </div>

        {/* Card */}
        <div key={step} className="ob-card" style={{
          background:"rgba(255,255,255,.06)", backdropFilter:"blur(20px)",
          borderRadius:24, padding:"36px 32px",
          border:"1.5px solid rgba(255,255,255,.1)",
          boxShadow:"0 32px 80px rgba(0,0,0,.3)",
        }}>
          <div style={{ fontSize:36, marginBottom:12 }}>{STEPS[step].icon}</div>
          <h2 style={{ fontFamily:"'Fraunces',serif", fontSize:24, fontWeight:900,
            color:"#fff", marginBottom:6 }}>{STEPS[step].title}</h2>
          <p style={{ fontSize:14, color:"rgba(255,255,255,.55)", marginBottom:28 }}>
            {STEPS[step].sub}
          </p>

          {/* ── STEP 0: Profile ── */}
          {step === 0 && (
            <div style={{ display:"flex", flexDirection:"column", gap:16 }}>
              <div>
                <label style={{ fontSize:12, fontWeight:700, color:"rgba(255,255,255,.6)", display:"block", marginBottom:6 }}>
                  Course / Program *
                </label>
                <input
                  className="ob-input"
                  list="ob-course-list"
                  value={profile.course}
                  onChange={e => setProfile(p => ({...p, course:e.target.value}))}
                  placeholder="Type or select your course…"
                  autoComplete="off"
                />
                <datalist id="ob-course-list">
                  {COURSES.map(c => <option key={c} value={c} />)}
                </datalist>
              </div>
              <div>
                <label style={{ fontSize:12, fontWeight:700, color:"rgba(255,255,255,.6)", display:"block", marginBottom:6 }}>
                  Year Level *
                </label>
                <select className="ob-input" value={profile.year_level}
                  onChange={e => setProfile(p => ({...p, year_level:e.target.value}))}>
                  <option value="">Select year…</option>
                  {["1st Year","2nd Year","3rd Year","4th Year","5th Year","Graduate"].map(y =>
                    <option key={y} value={y}>{y}</option>)}
                </select>
              </div>
              <div>
                <label style={{ fontSize:12, fontWeight:700, color:"rgba(255,255,255,.6)", display:"block", marginBottom:6 }}>
                  Brief Bio <span style={{ fontWeight:400, opacity:.6 }}>(optional)</span>
                </label>
                <textarea className="ob-input" rows={3} placeholder="Tell employers a bit about yourself…"
                  value={profile.bio} onChange={e => setProfile(p => ({...p, bio:e.target.value}))}
                  style={{ resize:"vertical" }} />
              </div>
              <div>
                <label style={{ fontSize:12, fontWeight:700, color:"rgba(255,255,255,.6)", display:"block", marginBottom:6 }}>
                  Skills <span style={{ fontWeight:400, opacity:.6 }}>(comma-separated)</span>
                </label>
                <input className="ob-input" placeholder="e.g. React, Excel, Photoshop, Customer Service…"
                  value={profile.skills} onChange={e => setProfile(p => ({...p, skills:e.target.value}))} />
              </div>
            </div>
          )}

          {/* ── STEP 1: Preferences ── */}
          {step === 1 && (
            <div style={{ display:"flex", flexDirection:"column", gap:20 }}>
              <div>
                <label style={{ fontSize:12, fontWeight:700, color:"rgba(255,255,255,.6)", display:"block", marginBottom:10 }}>
                  Preferred Industries <span style={{ fontWeight:400, opacity:.6 }}>(pick up to 4)</span>
                </label>
                <div style={{ display:"flex", flexWrap:"wrap", gap:8 }}>
                  {INDUSTRIES.map(ind => (
                    <button key={ind.label}
                      className={`chip${prefs.industries.includes(ind.label) ? " active" : ""}`}
                      onClick={() => toggleIndustry(ind.label)}>
                      {ind.icon} {ind.label}
                    </button>
                  ))}
                </div>
              </div>

              <div>
                <label style={{ fontSize:12, fontWeight:700, color:"rgba(255,255,255,.6)", display:"block", marginBottom:10 }}>
                  Work Setup Preference
                </label>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
                  {SETUPS.map(s => (
                    <div key={s.label} onClick={() => setPrefs(p => ({...p, setup:s.label}))}
                      style={{ border:`2px solid ${prefs.setup === s.label ? C.gold : "rgba(255,255,255,.12)"}`,
                        borderRadius:12, padding:"12px 14px", cursor:"pointer",
                        background: prefs.setup === s.label ? "rgba(245,166,35,.12)" : "rgba(255,255,255,.04)",
                        transition:"all .18s" }}>
                      <div style={{ fontSize:20, marginBottom:4 }}>{s.icon}</div>
                      <div style={{ fontSize:13, fontWeight:700, color: prefs.setup === s.label ? C.gold : "#fff" }}>{s.label}</div>
                      <div style={{ fontSize:11, color:"rgba(255,255,255,.45)" }}>{s.sub}</div>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <label style={{ fontSize:12, fontWeight:700, color:"rgba(255,255,255,.6)", display:"block", marginBottom:6 }}>
                  Preferred Location <span style={{ fontWeight:400, opacity:.6 }}>(city or region)</span>
                </label>
                <input className="ob-input" placeholder="e.g. Makati, Cebu City, Davao, Remote…"
                  value={prefs.location} onChange={e => setPrefs(p => ({...p, location:e.target.value}))} />
              </div>

              <div>
                <label style={{ fontSize:12, fontWeight:700, color:"rgba(255,255,255,.6)", display:"block", marginBottom:6 }}>
                  Required OJT Hours: <span style={{ color:C.gold }}>{prefs.hours} hrs</span>
                </label>
                <input type="range" min={200} max={800} step={50} value={prefs.hours}
                  onChange={e => setPrefs(p => ({...p, hours:parseInt(e.target.value)}))}
                  style={{ width:"100%", accentColor:C.gold }} />
                <div style={{ display:"flex", justifyContent:"space-between", fontSize:11, color:"rgba(255,255,255,.35)", marginTop:4 }}>
                  <span>200 hrs</span><span>800 hrs</span>
                </div>
              </div>
            </div>
          )}

          {/* ── STEP 2: Done ── */}
          {step === 2 && (
            <div style={{ textAlign:"center" }}>
              <div style={{ fontSize:64, marginBottom:16 }}>🎉</div>
              <p style={{ fontSize:15, color:"rgba(255,255,255,.7)", lineHeight:1.8, marginBottom:8 }}>
                Your profile is ready! We've matched you with <strong style={{ color:C.gold }}>
                {Math.floor(Math.random() * 40) + 20}+ OJT opportunities
                </strong> based on your preferences.
              </p>
              <p style={{ fontSize:13, color:"rgba(255,255,255,.45)" }}>
                You can update your profile anytime from the dashboard.
              </p>
            </div>
          )}

          {/* CTA */}
          <div style={{ marginTop:28, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            {step > 0 && step < 2 ? (
              <button onClick={() => setStep(s => s - 1)}
                style={{ background:"none", border:"none", color:"rgba(255,255,255,.45)",
                  fontSize:14, cursor:"pointer", fontFamily:"inherit", padding:0 }}>
                ← Back
              </button>
            ) : <div />}

            <button onClick={saveAndNext} disabled={saving}
              style={{
                background: saving ? "rgba(245,166,35,.5)" : C.gold,
                color: C.navy, border:"none", borderRadius:100,
                padding:"13px 32px", fontSize:15, fontWeight:800,
                cursor: saving ? "not-allowed" : "pointer",
                fontFamily:"inherit", transition:"all .2s",
              }}>
              {saving ? "Saving…" : step === 2 ? "Start Exploring OJT →" : "Continue →"}
            </button>
          </div>

          {/* Skip */}
          {step < 2 && (
            <div style={{ textAlign:"center", marginTop:16 }}>
              <button onClick={onComplete}
                style={{ background:"none", border:"none", color:"rgba(255,255,255,.3)",
                  fontSize:12, cursor:"pointer", fontFamily:"inherit", textDecoration:"underline" }}>
                Skip for now
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
